<template>
  <div>
    <vxe-grid
      ref="specProcessTable"
      border
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :loading="loading"
      :columns="tableColumns"
      :data="v_tableData"
      height="350"
      size="mini"
      resizable
      :checkbox-config="{ highlight: true, reserve: true }"
      :edit-config="{ enabled: true, trigger: 'click', mode: 'row' }"
      @edit-closed="editClosed"
      :edit-rules="rules"
      show-footer
      :footer-method="() => footerData"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span style="font-size: 14px; color: #606266">{{
              $l('table_head_process') || '工时工价'
            }}</span>
            <el-divider
              v-if="!disabled || !auditDisabled"
              direction="vertical"
            ></el-divider>
            <b-button
              class="mr-2"
              size="sm"
              v-if="!disabled || !auditDisabled"
              variant="outline-success"
              @click="$emit('add')"
              >{{ $l('btn_add_process') || '新增工序工艺' }}
            </b-button>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-danger"
              @click="batchDel()"
              v-if="!disabled || !auditDisabled"
            >
              <i class="el-icon-delete" />
              {{ $l('INDEX.btn_delete') || '删除' }}
            </b-button>
            <b-button
              class="mr-2"
              size="sm"
              v-if="!disabled || !auditDisabled"
              variant="outline-primary"
              @click="$emit('openChooseTechSpec')"
              >{{ $l('btn_copy_process') || '复制工序工艺' }}
            </b-button>
          </div>
        </slot>
      </template>
      <template v-slot:drag>
        <span class="drag-btn">
          <i class="vxe-icon--menu"></i>
        </span>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import {
  format,
  multiplyRound,
  multiply,
  divideRound,
  divide,
  add,
} from '@/libs/util.number.js'
import tableColumns from './table-columns'
import Sortable from 'sortablejs'
import { cloneDeep } from 'lodash'
export default {
  props: {
    disabled: { type: Boolean, default: false },
    auditDisabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    tableData: { type: Array, default: () => [] },
  },
  created() {
    this.rowDrop()
  },
  watch: {
    tableData: {
      handler() {
        this.v_tableData = cloneDeep(this.tableData || [])
      },
      immediate: true,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
      },
      tableColumns: tableColumns(this),
      v_tableData: [],
      format: (number) => format(number),
      rules: {
        techChargeUnit: [
          {
            required: true,
            message:
              this.$l('table_label_tech_pl_techChargeUnit') || '请选择单位...',
          },
        ],
        laborCost: [
          {
            type: 'number',
            required: true,
            message:
              this.$l('table_label_tech_pl_laborCost') || '请输入工费(元/H)...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        workforce: [
          {
            type: 'number',
            required: true,
            message:
              this.$l('table_label_tech_pl_workforce') || '请输入作业人数...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        processDuration: [
          {
            type: 'number',
            required: true,
            message:
              this.$l('table_label_tech_pl_processDuration') ||
              '请输入工序耗时(s)...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
      },
    }
  },
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.v_tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => totalColumnValues[t.field] || '')
      result[3] = this.$l('INDEX.total') || '合计'
      return [result]
    },
  },
  methods: {
    setCopyTableData(data) {
      if (!data || !data.length) return
      const tableData = data
        .map((m) => {
          return {
            ...m,
            orderTechPricingItemCode: '',
            orderTechPricingSpecCode: '',
            orderTechPricingCode: '',
          }
        })
        .filter(
          (i) =>
            this.v_tableData.findIndex(
              (j) => j.pdTechDictCode === i.pdTechDictCode
            ) < 0
        )
      this.v_tableData.push(...tableData)
    },
    setTableData(data) {
      if (!data || !data.length) return
      const tableData = data
        .map((m) => {
          return {
            ...m,
            processName: m.v_pdProcessDictStep,
            remark: m.techDesc,
          }
        })
        .filter(
          (i) =>
            this.v_tableData.findIndex(
              (j) => j.pdTechDictCode === i.pdTechDictCode
            ) < 0
        )
      this.v_tableData.push(...tableData)
    },
    getTableData() {
      return this.v_tableData
    },
    del(row) {
      let index = this.$refs.specProcessTable.getRowIndex(row)
      this.v_tableData.splice(index, 1)
    },
    batchDel() {
      const data = this.getCheckboxRecords()
      if (!data || !data.length) return

      this.$confirm(
        this.$l('tips_delete_data') || '您确定要删除所勾选数据吗?'
      ).then((type) => {
        if (type === 'confirm') {
          this.$refs.specProcessTable.removeCheckboxRow()
          const deleteCodes = new Set(data.map((d) => d.pdTechDictCode))
          this.v_tableData = this.v_tableData.filter(
            (row) => !deleteCodes.has(row.pdTechDictCode)
          )
        }
      })
    },

    async validate() {
      return !(await this.$refs.specProcessTable.validate(true))
    },
    getCheckboxRecords() {
      const data = this.$refs.specProcessTable.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          message: this.$l('INDEX.tips_select_data') || '请选择需要操作的数据',
          type: 'warning',
        })
        return
      }
      return data
    },
    editClosed({ row }) {
      const { processDuration, laborCost, workforce } = row
      //processDuration 工序耗时 laborCost 工费  capacity 产能  laborPrice 工价
      if (!processDuration) {
        row.capacity = 0
        row.laborPrice = 0
        return
      }
      row.capacity = divideRound(3600, processDuration, 0)
      row.laborPrice = multiplyRound(
        multiply(divide(laborCost, 3600), workforce),
        processDuration,
        3
      )
      this.$refs.specProcessTable.updateFooter()
    },
    rowDrop() {
      this.$nextTick(() => {
        const xTable = this.$refs.specProcessTable
        this.sortable = Sortable.create(
          xTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'),
          {
            handle: '.drag-btn',
            onEnd: ({ newIndex, oldIndex }) => {
              if (newIndex == oldIndex) return

              const data = [...this.v_tableData]
              const currRow = data[oldIndex]

              if (newIndex > oldIndex) {
                for (let i = oldIndex + 1; i <= newIndex; i++) {
                  data[i - 1] = data[i]
                }
              } else {
                for (let i = oldIndex - 1; i >= newIndex; i--) {
                  data[i + 1] = data[i]
                }
              }
              data[newIndex] = currRow
              this.v_tableData = []
              setTimeout(() => {
                this.v_tableData = [...data]
              }, 0)
            },
          }
        )
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.workshop-process-table .drag-btn {
  cursor: move;
  font-size: 12px;
}
</style>
